/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { User, UserFromJSON, UserFromJSONTyped, UserToJSON } from "./User";

/**
 *
 * @export
 * @interface UserListControllerResponse
 */
export interface UserListControllerResponse {
  /**
   *
   * @type {Array<User>}
   * @memberof UserListControllerResponse
   */
  data?: Array<User> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof UserListControllerResponse
   */
  error?: ErrorResponse;
}

export function UserListControllerResponseFromJSON(json: any): UserListControllerResponse {
  return UserListControllerResponseFromJSONTyped(json, false);
}

export function UserListControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserListControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
      ? null
      : (json["data"] as Array<any>).map(UserFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function UserListControllerResponseToJSON(value?: UserListControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined ? undefined : value.data === null ? null : (value.data as Array<any>).map(UserToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
